import servicioObjetos from './ServicioObjetos';
import servicioFormatos from './ServicioFormatos';
const ServicioDocumentoIDSE = {

    generarCuerpo(ttLoteSolicitudIdse) {
        let registroPatronal = this.rellenarEspaciosDerecha((ttLoteSolicitudIdse.registroPatronal.split('-')[0]).trim(), 11, " ");
        let nss = this.rellenarEspaciosDerecha(ttLoteSolicitudIdse.trIdseMovimiento.tcTrabajador.numeroSeguridadSocial, 10, " ");
        let digitoverificador = this.rellenarEspaciosDerecha(ttLoteSolicitudIdse.trIdseMovimiento.digitoVerificador, 1, " ");
        let primerApellido = this.rellenarEspaciosDerecha(ttLoteSolicitudIdse.trIdseMovimiento.tcTrabajador.primerApellido, 27, " ");
        let segundoApellido = "";
        if (servicioObjetos.esObjetoVacio(ttLoteSolicitudIdse.trIdseMovimiento.tcTrabajador.segundoApellido)) {
            segundoApellido = this.rellenarEspaciosDerecha(segundoApellido, 27, " ");
        } else {
            segundoApellido = this.rellenarEspaciosDerecha(ttLoteSolicitudIdse.trIdseMovimiento.tcTrabajador.segundoApellido, 27, " ");
        }
        let nombre = this.rellenarEspaciosDerecha(ttLoteSolicitudIdse.trIdseMovimiento.tcTrabajador.nombre, 27, " ");
        let sueldoBase = "";
        if (servicioObjetos.esObjetoVacio(ttLoteSolicitudIdse.trIdseMovimiento.salarioDiarioIntegrado)) {
            sueldoBase = this.rellenarEspaciosDerecha(sueldoBase, 12, " ");
        } else {
            sueldoBase = this.rellenarEspaciosDerecha(this.formatoSueldoBase(ttLoteSolicitudIdse.trIdseMovimiento.salarioDiarioIntegrado), 12, " ");
        }

        let tipoTrabajador = "";
        if (servicioObjetos.esObjetoVacio(ttLoteSolicitudIdse.trIdseMovimiento.tipoTrabajador)) {
            tipoTrabajador = this.rellenarEspaciosDerecha(tipoTrabajador, 1, " ");
        } else {
            tipoTrabajador = this.rellenarEspaciosDerecha(ttLoteSolicitudIdse.trIdseMovimiento.tipoTrabajador, 1, " ");
        }
        let tipoSalario = "";
        if (servicioObjetos.esObjetoVacio(ttLoteSolicitudIdse.trIdseMovimiento.tipoSalario)) {
            tipoSalario = this.rellenarEspaciosDerecha(tipoSalario, 1, " ");
        } else {
            tipoSalario = this.rellenarEspaciosDerecha(ttLoteSolicitudIdse.trIdseMovimiento.tipoSalario, 1, " ");
        }
        let jornadaReducida = "";
        if (servicioObjetos.esObjetoVacio(ttLoteSolicitudIdse.trIdseMovimiento.jornadaReducida)) {
            jornadaReducida = this.rellenarEspaciosDerecha(jornadaReducida, 1, " ");
        } else {
            jornadaReducida = this.rellenarEspaciosDerecha(ttLoteSolicitudIdse.trIdseMovimiento.jornadaReducida, 1, " ");
        }
        let fechaMovimiento = this.rellenarEspaciosDerecha(ttLoteSolicitudIdse.trIdseMovimiento.fechaMovimiento, 8, " ");
        let unidadMedicaFamiliar = "000  ";
        if (!servicioObjetos.esObjetoVacio(ttLoteSolicitudIdse.trIdseMovimiento.umf))
            unidadMedicaFamiliar = this.rellenarEspaciosDerecha(ttLoteSolicitudIdse.trIdseMovimiento.umf, 5, " ");
        let tipoMovimiento = this.rellenarEspaciosDerecha(ttLoteSolicitudIdse.trIdseMovimiento.tipoMovimiento, 2, " ");
        let numeroGuia = "00000";
        let claveTrabajador = "0000000000 ";
        let curp = "";
        if (servicioObjetos.esObjetoVacio(ttLoteSolicitudIdse.trIdseMovimiento.curp)) {
            curp = "000000000000000000";
        } else {
            curp = this.rellenarEspaciosDerecha(ttLoteSolicitudIdse.trIdseMovimiento.curp, 18, " ");
        }
        let ultimoDigito = "9";
        let causaBaja = ttLoteSolicitudIdse.trIdseMovimiento.causaBaja;

        if (tipoMovimiento === "02") {
            unidadMedicaFamiliar = this.rellenarEspaciosDerecha("", 5, " ");
            let claveTrabajador = "0000000000";
            numeroGuia = "00000";
            curp = this.rellenarEspaciosDerecha("", 18, " ");
            return registroPatronal + nss + digitoverificador + primerApellido + segundoApellido + nombre + sueldoBase + tipoTrabajador + tipoSalario + jornadaReducida + fechaMovimiento + unidadMedicaFamiliar + tipoMovimiento + numeroGuia + claveTrabajador + causaBaja + curp + ultimoDigito;
        } else {
            return registroPatronal + nss + digitoverificador + primerApellido + segundoApellido + nombre + sueldoBase + tipoTrabajador + tipoSalario + jornadaReducida + fechaMovimiento + unidadMedicaFamiliar + tipoMovimiento + numeroGuia + claveTrabajador + curp + ultimoDigito;
        }
    },
    rellenarEspaciosDerecha(cadena, longitud, complemento) {
        while (cadena.length < longitud) {
            cadena = cadena + complemento;
        }
        return cadena;
    }, rellenarAlaIzquierda(cadena, longitud, complemento) {
        while (cadena.length < longitud) {
            cadena = complemento + cadena;
        }
        return cadena;
    },
    formatoSueldoBase(cadena) {
        cadena = Number(cadena).toFixed(2);
        cadena = cadena.replace('.', '');
        while (cadena.length < 6) {
            cadena = "0" + cadena;
        }
        return cadena;
    },
    generarCuerpo2023(movimiento) {
        let registroPatronal = this.rellenarEspaciosDerecha(movimiento.registroPatronal.split("-")[0].trim(), 11, " ");
        let nss = this.rellenarEspaciosDerecha(movimiento.tcTrabajador.numeroSeguridadSocial, 10, " ");
        let digitoverificador = this.rellenarEspaciosDerecha(movimiento.digitoVerificador, 1, " ");
        let primerApellido = this.rellenarEspaciosDerecha(movimiento.tcTrabajador.primerApellido, 27, " ");
        let segundoApellido = "";
        if (servicioObjetos.esObjetoVacio(movimiento.tcTrabajador.segundoApellido)) {
            segundoApellido = this.rellenarEspaciosDerecha(segundoApellido, 27, " ");
        } else {
            segundoApellido = this.rellenarEspaciosDerecha(movimiento.tcTrabajador.segundoApellido, 27, " ");
        }
        let nombre = this.rellenarEspaciosDerecha(movimiento.tcTrabajador.nombre, 27, " ");
        let sueldoBase = "";
        if (servicioObjetos.esObjetoVacio(movimiento.salarioDiarioIntegrado)) {
            sueldoBase = this.rellenarEspaciosDerecha(sueldoBase, 12, " ");
        } else {
            sueldoBase = this.rellenarEspaciosDerecha(this.formatoSueldoBase(movimiento.salarioDiarioIntegrado), 12, " ");
        }

        let tipoTrabajador = "";
        if (servicioObjetos.esObjetoVacio(movimiento.tipoTrabajador)) {
            tipoTrabajador = this.rellenarEspaciosDerecha(tipoTrabajador, 1, " ");
        } else {
            tipoTrabajador = this.rellenarEspaciosDerecha(movimiento.tipoTrabajador, 1, " ");
        }
        let tipoSalario = "";
        if (servicioObjetos.esObjetoVacio(movimiento.tipoSalario)) {
            tipoSalario = this.rellenarEspaciosDerecha(tipoSalario, 1, " ");
        } else {
            tipoSalario = this.rellenarEspaciosDerecha(movimiento.tipoSalario, 1, " ");
        }
        let jornadaReducida = "";
        if (servicioObjetos.esObjetoVacio(movimiento.jornadaReducida)) {
            jornadaReducida = this.rellenarEspaciosDerecha(jornadaReducida, 1, " ");
        } else {
            jornadaReducida = this.rellenarEspaciosDerecha(movimiento.jornadaReducida, 1, " ");
        }
        let fechaMovimiento = this.rellenarEspaciosDerecha(servicioFormatos.formatearFechaStringArchivoIdse(movimiento.fechaMovimiento), 8, " ");
        let unidadMedicaFamiliar = "000  ";
        if (!servicioObjetos.esObjetoVacio(movimiento.umf))
            unidadMedicaFamiliar = this.rellenarEspaciosDerecha(movimiento.umf, 5, " ");
        let tipoMovimiento = this.rellenarEspaciosDerecha(movimiento.tipoMovimiento, 2, " ");
        let numeroGuia = "00000";
        let claveTrabajador = this.rellenarAlaIzquierda(servicioObjetos.esObjetoVacio(movimiento.claveTrabajador) ? "" : movimiento.claveTrabajador, 10, "0");//"0000000000 ";Se cambia la logica, son 10 ceros y un espacio (FILLER) pero se modifica por el valor real
        claveTrabajador = this.rellenarEspaciosDerecha(claveTrabajador, 11, " ");//En teoría debe de crear el valor anterior es decir "0000000000 " 
        let curp = "";
        if (servicioObjetos.esObjetoVacio(movimiento.curp)) {
            curp = "000000000000000000";
        } else {
            curp = this.rellenarEspaciosDerecha(movimiento.curp, 18, " ");
        }
        let ultimoDigito = "9";
        let causaBaja = movimiento.causaBaja;

        if (tipoMovimiento === "02") {
            unidadMedicaFamiliar = this.rellenarEspaciosDerecha("", 5, " ");
            let claveTrabajador = "0000000000";
            numeroGuia = "00000";
            curp = this.rellenarEspaciosDerecha("", 18, " ");
            return registroPatronal + nss + digitoverificador + primerApellido + segundoApellido + nombre + sueldoBase + tipoTrabajador + tipoSalario + jornadaReducida + fechaMovimiento + unidadMedicaFamiliar + tipoMovimiento + numeroGuia + claveTrabajador + causaBaja + curp + ultimoDigito;
        } else {
            return registroPatronal + nss + digitoverificador + primerApellido + segundoApellido + nombre + sueldoBase + tipoTrabajador + tipoSalario + jornadaReducida + fechaMovimiento + unidadMedicaFamiliar + tipoMovimiento + numeroGuia + claveTrabajador + curp + ultimoDigito;
        }
    }
}

export default ServicioDocumentoIDSE;